import { makeAutoObservable } from 'mobx'

export default class ModalStore {
  name: string = ''
  email: string = ''
  position: string = ''
  company: string = ''
  phone: string = ''
  messageModal: boolean = false
  redirectModal: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  setUserName(name: string) {
    this.name = name
  }
  setEmail(email: string) {
    this.email = email
  }
  setPosition(position: string) {
    this.position = position
  }
  setCompany(company: string) {
    this.company = company
  }
  setPhone(phone: string) {
    this.phone = phone
  }
  showMessageModal(status: boolean) {
    this.messageModal = status
  }
  clearMessageModal() {
    this.name = ''
    this.email = ''
    this.position= ''
    this.company = ''
    this.phone = ''
  }
  showRedirectModal(status: boolean) {
    this.redirectModal = status
  }
}
